import React from 'react'
import { LEGEND, INSTRUMENT_TYPES_FOR_LEGEND } from '../utils/constants'

const TimelineLegend = () => {
  return (
    <div className='study-timeline-legend'>
      <div className='study-timeline-legend-item'>
        <span className='legend-color cycle' />
        <span>{LEGEND.CYCLE_ACTIVE}</span>
      </div>
      <div className='study-timeline-legend-item'>
        <span className='legend-color visit' />
        <span>{LEGEND.VISIT_FOR_DAY}</span>
      </div>
      {/* <div className='study-timeline-legend-item'>
        <span className='legend-color instrument' />
        <span>{LEGEND.INSTRUMENT_DEPLOYMENT_DAY}</span>
      </div> */}
      {/* GOLD-12270: Consent & Announcement legend hidden — not currently displayed/used
      <div className='study-timeline-legend-consent-announcement'>
        <span className='study-timeline-legend-consent-announcement-title'>Consent & Announcement</span>
        {CONSENT_ANNOUNCEMENT_LEGEND.map(({ key, label }) => (
          <div key={key} className='study-timeline-legend-item'>
            <span className={`legend-color instrument-type-${key.toLowerCase()}`} />
            <span>{label}</span>
          </div>
        ))}
      </div>
      */}
      <div className='study-timeline-legend-instrument-types'>
        <span className='study-timeline-legend-instrument-types-title'>Instrument types</span>
        {INSTRUMENT_TYPES_FOR_LEGEND.filter(
          // GOLD-12270: Diary legend hidden — not currently displayed/used
          ({ key }) => key !== 'EDIARY',
        ).map(({ key, label }) => (
          <div key={key} className='study-timeline-legend-item'>
            <span className={`legend-color instrument-type-${key.toLowerCase()}`} />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TimelineLegend

